import { UIText1, UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './Underground.css';
import { UndergroundIcon } from './components/UndergroundIcon';
import { GeoTravelTime } from './components/GeoTravelTime';
import { IUnderground } from 'shared/types/geo';

export interface IUndergroundProps {
  regionId: number;
  underground: IUnderground;
  small?: boolean;
}

export const Underground: React.FC<IUndergroundProps> = ({ regionId, underground, small }) => {
  const { lineColor, name, time, transportType, underConstruction } = underground;

  const Component = small ? UIText2 : UIText1;

  return (
    <div className={clsx(styles['container'], underConstruction && styles['under-construction'])}>
      {lineColor && <UndergroundIcon className={styles['icon']} color={`#${lineColor}`} regionId={[regionId]} />}
      <span className={styles['name']}>
        <Component display="inline">{name}</Component>
      </span>
      {time && transportType && <GeoTravelTime small time={time} transportType={transportType} />}
    </div>
  );
};
